import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { getSelectionBoxStyles, Radio } from '@grandvisionhq/elements';

const SelectionBoxRadio = (props)=>{
    const classNames = getSelectionBoxStyles({
        isSelected: props.checked,
        isDisabled: props.disabled,
        className: props.className
    });
    return /*#__PURE__*/ React.createElement(Radio, swcHelpers.extends({}, props, {
        className: classNames
    }));
};

export { SelectionBoxRadio };
//# sourceMappingURL=SelectionBoxRadio.js.map
